<template>
    <span class="res-btn" v-if="showBtn">
        <slot></slot>
    </span>
</template>

<script>
    export default {
        props: {
            keyName: String
        },
        name: 'res-view',
        computed: {
            showBtn () {
                if (this.$store.state.user.isROOT) return true;
                return this.$store.state.user.resKeys.has(this.keyName);
            }
        }
    }
</script>

<style scoped>

</style>